import axios from 'axios'
import { deviceUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 查看摄像头列表
export function deviceFind(params) {
  const url = deviceUrl + '/device/camera/find'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('查看摄像头列表', '监控中心', res)
    }
    return Promise.resolve(res.data)
  })
}
// 获取摄像头直播流
export function deviceStreamGet(params) {
  const url = deviceUrl + '/device/camera/stream/get'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('摄像头直播流', '监控中心', res)
    }
    return Promise.resolve(res.data)
  })
}
// 停止摄像头直播流
export function deviceStreamStop(params) {
  const url = deviceUrl + '/device/camera/stream/stop'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('停止摄像头直播流', '监控中心', res)
    }
    return Promise.resolve(res.data)
  })
}

// 延长摄像头关闭时间
export function streamExtend(params) {
  const url = deviceUrl + '/device/camera/stream/extend'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '延长摄像头关闭时间', res)
    }
    return Promise.resolve(res.data)
  })
}
